import React, { useEffect, useRef, useState } from "react";
import { SlideWorkflow } from "./SlideWorkflow";
import { SlideAgents } from "./SlideAgents";
import { SlideChart } from "./SlideChart";

const TITLES = ["Workflow", "Agents", "Technical · Fundamental"];
const N = TITLES.length;

export const FloorSlideshow = ({ st, positions, hidden }) => {
  const [i, setI] = useState(0);
  const [loop, setLoop] = useState(0);
  const [hold, setHold] = useState(0);
  const touch = useRef(null);
  useEffect(() => {
    const t = setTimeout(() => setI((x) => (x + 1) % N), Math.max(12000, hold - Date.now()));
    return () => clearTimeout(t);
  }, [i, hold]);
  useEffect(() => { if (i === 0) setLoop((l) => l + 1); }, [i]);
  const jump = (n) => { setI((n + N) % N); setHold(Date.now() + 20000); };
  const slides = [<SlideWorkflow st={st} />, <SlideAgents st={st} />, <SlideChart positions={positions} loop={Math.max(0, loop - 1)} hidden={hidden} />];
  return (
    <section className="fc-panel p-3 flex flex-col h-[560px] lg:h-full min-h-0" data-testid="floor-slideshow" data-slide={i}
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { const dx = e.changedTouches[0].clientX - (touch.current ?? 0); if (Math.abs(dx) > 50) jump(i + (dx < 0 ? 1 : -1)); }}>
      <div className="flex items-center justify-between mb-2">
        <p className="fc-label">{TITLES[i]}</p>
        <div className="flex gap-2" data-testid="floor-slide-dots">
          {TITLES.map((t, n) => (
            <button key={t} onClick={() => jump(n)} aria-label={t} data-testid={`floor-slide-dot-${n}`}
              className={`h-2 rounded-full transition-[width,background-color] duration-300 ${n === i ? "w-6 bg-[#00F0FF]" : "w-2 bg-cyan-200/25"}`} />
          ))}
        </div>
      </div>
      <div key={i} className="flex-1 min-h-0 fc-caption" onClick={() => setHold(Date.now() + 20000)}>{slides[i]}</div>
    </section>
  );
};
